module.exports = __webpack_public_path__ + "img/add_localsotrm_img.3f4c7fd0.svg";